import styled from 'styled-components';

/**
 * A cor do tenant (`theme.primary`, do ThemeProvider do MainContent) nos componentes do antd
 * que o createGlobalStyle não cobre. Sem isto eles saem no azul padrão do antd (#1890ff),
 * que não é a cor de nenhum tenant. O themeColors.test.tsx confere a interpolação.
 */
export const Page = styled.div`
  position: relative;
  overflow-y: auto;
  padding: 0 2% 48px;

  .ant-tabs-tab {
    color: #717171;
    padding: 12px 0;
  }
  .ant-tabs-tab:hover,
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.primary};
  }
  .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.primary};
  }

  .ocpi-row-clickable {
    cursor: pointer;
  }
  .ocpi-row-selected > td {
    background: #fafafa;
  }
  .ocpi-row-selected > td:first-child {
    box-shadow: inset 3px 0 0 ${({ theme }) => theme.primary};
  }

  .ant-radio-button-wrapper:hover {
    color: ${({ theme }) => theme.primary};
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: ${({ theme }) => theme.primary};
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.hoveredDiv};
  }
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
  .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #ffffff;
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-pagination-item-active,
  .ant-pagination-item:hover,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.primary};
  }
  .ant-pagination-item-active a,
  .ant-pagination-item:hover a,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: ${({ theme }) => theme.primary};
  }

  .ant-input-search .ant-input:hover,
  .ant-input-search .ant-input:focus,
  .ant-input-search-button:hover,
  .ant-input-search-button:focus {
    border-color: ${({ theme }) => theme.primary};
  }
  .ant-input-search-button:hover,
  .ant-input-search-button:focus {
    color: ${({ theme }) => theme.primary};
  }

  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-alert-info {
    background-color: ${({ theme }) => theme.selectedDiv};
    border-color: ${({ theme }) => theme.selectedDiv};
  }
  .ant-alert-info .ant-alert-icon {
    color: ${({ theme }) => theme.primary};
  }

  .ant-table-row {
    cursor: pointer;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 21px;
  font-weight: normal;
  font-family: 'Roboto';
  color: #2a2a2a;
`;

export const Subtitle = styled.div`
  color: #717171;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const Muted = styled.span`
  color: #717171;
  font-size: 12px;
`;

export const Mono = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
`;

export const Panel = styled.section`
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  padding: 16px 20px;
  margin-bottom: 16px;
  min-width: 0;

  h2 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px;
  }
`;

export const Grid = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns || 4}, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Kpi = styled.button`
  text-align: left;
  border: none;
  cursor: pointer;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  &:disabled {
    cursor: default;
  }
  .label {
    color: #444444;
  }
  .value {
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: #2a2a2a;
  }
  .sub {
    color: #717171;
    font-size: 12px;
  }
`;

export const DistBar = styled.div`
  display: flex;
  height: 12px;
  border-radius: 4px;
  overflow: hidden;
  gap: 2px;
  margin-bottom: 12px;
`;

export const DistRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
  border-bottom: 1px solid #f1f1f1;

  .swatch {
    width: 10px;
    height: 10px;
    border-radius: 2px;
  }
  .n {
    width: 32px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }
  .label {
    flex-grow: 1;
  }
`;

export const ConnectorCard = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }
  .prices {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    border-top: 1px solid #f1f1f1;
    padding-top: 10px;
  }
`;

export const MapBox = styled.div`
  height: 520px;
  border-radius: 4px;
  overflow: hidden;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  text-decoration: underline;
`;

export const Timeline = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  li {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
    padding-top: 30px;
  }
  li::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 26px;
    right: 0;
    height: 2px;
    background: #e5e5e5;
  }
  li:last-child::before {
    display: none;
  }
  .dot {
    position: absolute;
    top: 0;
    left: 0;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid #aeaeae;
    background: #ffffff;
  }
  li.done .dot {
    border-color: #245a17;
    background: #dff0da;
  }
  li.current .dot {
    border-color: ${({ theme }) => theme.primary};
    background: ${({ theme }) => theme.selectedDiv};
  }
  li.error .dot {
    border-color: #a3231d;
    background: #fbe4e3;
  }
`;

/** Barra de energia por estação: dado, não status, então vai na cor do tenant. */
export const EnergyBar = styled.div`
  width: 40%;
  height: 8px;
  background: #f1f1f1;
  border-radius: 4px;

  span {
    display: block;
    height: 8px;
    border-radius: 4px;
    background: ${({ theme }) => theme.primary};
  }
`;

/** Proporção entra no feed x descartada de um operador: status, então nas cores de status. */
export const FeedBar = styled.div`
  display: flex;
  width: 120px;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  background: #f1f1f1;

  span {
    display: block;
    height: 6px;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
  h2 {
    margin: 0;
  }
`;

/** Direção do fluxo OCPI (enviando x recebendo) no topo de cada aba de estações. */
export const DirectionBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  border-left: 4px solid ${({ theme }) => theme.primary};

  .icon {
    font-size: 20px;
    color: ${({ theme }) => theme.primary};
  }
  .title {
    font-weight: 600;
    color: #2a2a2a;
  }
  .text {
    color: #717171;
    font-size: 12px;
  }
`;

export const FlowCard = styled.button`
  text-align: left;
  border: 1px solid transparent;
  cursor: pointer;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
  .head {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .icon {
    flex: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #ffffff;
    background: ${({ theme }) => theme.primary};
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #2a2a2a;
  }
  .who {
    color: #717171;
    font-size: 12px;
  }
  .numbers {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
  }
  .n {
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: #2a2a2a;
  }
  .l {
    color: #717171;
    font-size: 12px;
  }
  .cta {
    color: ${({ theme }) => theme.primary};
    font-size: 13px;
  }
`;

export const TabLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  .count {
    font-size: 11px;
    padding: 0 6px;
    border-radius: 8px;
    background: #f1f1f1;
    color: #717171;
    font-variant-numeric: tabular-nums;
  }
`;

/**
 * Detalhe em drawer à direita, no mesmo desenho do módulo Interoperabilidade
 * (organisms/Interoperability/styled, que não existe na linha master): cartões com título em
 * caixa alta e linhas rótulo → valor.
 */
export const DetailCard = styled.div`
  background: #fff;
  border: 1px solid #e9ebee;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 10px;
`;

export const DetailTitle = styled.h4`
  margin: 0 0 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #8a9099;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  padding: 6px 0;
  border-bottom: 1px solid #f2f4f6;
  font-size: 12.5px;
  color: #6b7280;

  &:last-of-type {
    border-bottom: none;
  }
  &.clickable {
    cursor: pointer;
  }
  &.clickable:hover {
    background: #fafafa;
  }
`;

export const DetailValue = styled.span`
  color: #2d3339;
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;

  a {
    color: ${({ theme }) => theme.primary};
  }
`;

export const DetailMono = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  word-break: break-all;
`;

export const DetailHint = styled.p`
  margin: 8px 0 0;
  font-size: 11.5px;
  color: #8a9099;
`;

/** Cabeçalho de seção minimizável da visão geral. */
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 4px 0 12px;

  h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
`;

/** Resumo de uma seção minimizada: uma linha, ainda clicável. */
export const CollapsedSummary = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;

  button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: none;
    cursor: pointer;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    padding: 8px 14px;
    color: #2a2a2a;
  }
  button:hover {
    color: ${({ theme }) => theme.primary};
  }
  .icon {
    color: ${({ theme }) => theme.primary};
  }
  strong {
    font-variant-numeric: tabular-nums;
  }
`;
